// FETCH ALL GENERAL-PO DETAILS
export const FETCH_GENERAL_DC_DETAILS_REQUEST = 'FETCH_GENERAL_DC_DETAILS_REQUEST';
export const FETCH_GENERAL_DC_DETAILS_SUCCESS = 'FETCH_GENERAL_DC_DETAILS_SUCCESS';
export const FETCH_GENERAL_DC_DETAILS_FAILURE = 'FETCH_GENERAL_DC_DETAILS_FAILURE';

// FETCH ALL GENERAL-PO DETAILS
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_FAILURE';

// CREATE GENERAL-PO DETAILS
export const CREATE_GENERAL_DC_DETAILS_REQUEST = 'CREATE_GENERAL_DC_DETAILS_REQUEST';
export const CREATE_GENERAL_DC_DETAILS_SUCCESS = 'CREATE_GENERAL_DC_DETAILS_SUCCESS';
export const CREATE_GENERAL_DC_DETAILS_FAILURE = 'CREATE_GENERAL_DC_DETAILS_FAILURE';

// UPDATE GENERAL-PO DETAILS
export const UPDATE_GENERAL_DC_DETAILS_REQUEST = 'UPDATE_GENERAL_DC_DETAILS_REQUEST';
export const UPDATE_GENERAL_DC_DETAILS_SUCCESS = 'UPDATE_GENERAL_DC_DETAILS_SUCCESS';
export const UPDATE_GENERAL_DC_DETAILS_FAILURE = 'UPDATE_GENERAL_DC_DETAILS_FAILURE';

// FETCH SINGLE STATE OF GENERAL-PO DETAILS
export const FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST = 'FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE = 'FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE';

// DELETE GENERAL-PO DETAILS
export const DELETE_GENERAL_DC_DETAILS_REQUEST = 'DELETE_GENERAL_DC_DETAILS_REQUEST';
export const DELETE_GENERAL_DC_DETAILS_SUCCESS = 'DELETE_GENERAL_DC_DETAILS_SUCCESS';
export const DELETE_GENERAL_DC_DETAILS_FAILURE = 'DELETE_GENERAL_DC_DETAILS_FAILURE';

export const RESET_GENERAL_DC_DETAILS_INFO = 'RESET_GENERAL_DC_DETAILS_INFO';

export const RESET_ADMIN_DC_DETAILS_INFO = 'RESET_ADMIN_DC_DETAILS_INFO';

export const CREATE_GENERAL_DC_DETAILS_FORM = 'CREATE_GENERAL_DC_DETAILS_FORM';

export const UPDATE_GENERAL_DC_DETAILS_FORM = 'UPDATE_GENERAL_DC_DETAILS_FORM';

export const FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_REQUEST = 'FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_REQUEST';
export const FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_SUCCESS = 'FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_SUCCESS';
export const FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_FAILURE = 'FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_FAILURE';


export const FETCH_GENERAL_DC_DETAILS_REQUEST_GET = 'FETCH_GENERAL_DC_DETAILS_REQUEST_GET';
export const FETCH_GENERAL_DC_DETAILS_SUCCESS_GET = 'FETCH_GENERAL_DC_DETAILS_SUCCESS_GET';
export const FETCH_GENERAL_DC_DETAILS_FAILURE_GET = 'FETCH_GENERAL_DC_DETAILS_FAILURE_GET';




export const CLOSE_BTN_POST_REQUEST_ALL_GENERAL_POST = 'CLOSE_BTN_POST_REQUEST_ALL_GENERAL_POST';
export const CLOSE_BTN_POST_SUCCESS_ALL_GENERAL_POST = 'CLOSE_BTN_POST_SUCCESS_ALL_GENERAL_POST';
export const CLOSE_BTN_POST_FAILURE_ALL_GENERAL_POST = 'CLOSE_BTN_POST_FAILURE_ALL_GENERAL_POST';


export const FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_REQUEST = 'FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_REQUEST';
export const FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_SUCCESS = 'FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_SUCCESS';
export const FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_FAILURE = 'FETCH_GENERAL_DC_DETAILS_CLOSE_ALL_FAILURE';

export const FETCH_MISCELLANEOUS_ITEM_REQUEST = 'FETCH_MISCELLANEOUS_ITEM_REQUEST';
export const FETCH_MISCELLANEOUS_ITEM_SUCCESS = 'FETCH_MISCELLANEOUS_ITEM_SUCCESS';
export const FETCH_MISCELLANEOUS_ITEM_FAILURE = 'FETCH_MISCELLANEOUS_ITEM_FAILURE';

export const GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE'


export const RESET_DEFAULT_USERFORM_DETAILS_FORM = 'RESET_DEFAULT_USERFORM_DETAILS_FORM'